export default function OAuthButtons() {
  const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8080'

  const handleGoogleLogin = () => {
    // Redirect to backend OAuth endpoint
    window.location.href = `${API_URL}/api/auth/google`
  }

  return (
    <div className="oauth-buttons">
      <button type="button" onClick={handleGoogleLogin} className="btn-oauth btn-google">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M18.1713 8.36788H17.5001V8.33329H10.0001V11.6666H14.7096C14.0225 13.6069 12.1763 15 10.0001 15C7.23882 15 5.00007 12.7612 5.00007 9.99996C5.00007 7.23871 7.23882 4.99996 10.0001 4.99996C11.2746 4.99996 12.4342 5.48079 13.3171 6.26621L15.6742 3.90913C14.1859 2.52204 12.1951 1.66663 10.0001 1.66663C5.39798 1.66663 1.66675 5.39788 1.66675 9.99996C1.66675 14.602 5.39798 18.3333 10.0001 18.3333C14.6022 18.3333 18.3334 14.602 18.3334 9.99996C18.3334 9.44121 18.2767 8.89579 18.1713 8.36788Z" fill="#FFC107"/>
          <path d="M2.6275 6.12121L5.36542 8.12913C6.10625 6.29496 7.90042 4.99996 10.0004 4.99996C11.2750 4.99996 12.4346 5.48079 13.3175 6.26621L15.6746 3.90913C14.1862 2.52204 12.1954 1.66663 10.0004 1.66663C6.79917 1.66663 4.02334 3.47371 2.6275 6.12121Z" fill="#FF3D00"/>
          <path d="M10.0004 18.3333C12.1525 18.3333 14.1087 17.5095 15.5871 16.1691L13.0079 13.9875C12.1431 14.6452 11.0864 15.0008 10.0004 15C7.83294 15 5.99211 13.6179 5.29878 11.6891L2.58211 13.783C3.96044 16.4816 6.76128 18.3333 10.0004 18.3333Z" fill="#4CAF50"/>
          <path d="M18.1713 8.36788H17.5V8.33329H10V11.6666H14.7096C14.3809 12.5902 13.7889 13.3972 13.0067 13.9879L13.0079 13.9871L15.5871 16.1687C15.4046 16.3354 18.3333 14.1666 18.3333 9.99996C18.3333 9.44121 18.2767 8.89579 18.1713 8.36788Z" fill="#1976D2"/>
        </svg>
        Continuer avec Google
      </button>

      {/* Vous pouvez ajouter d'autres providers ici (GitHub, LinkedIn, etc.) */}
    </div>
  )
}
